import { render } from "./ColoredStatusChip.vue?vue&type=template&id=7ee8cab5"
import script from "./ColoredStatusChip.vue?vue&type=script&lang=js"
export * from "./ColoredStatusChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__